<cx-profile-dropdown
  *transloco="let t"
  [firstname]="claimedIdentity['given_name']"
  [lastname]="claimedIdentity['family_name']"
  [email]="claimedIdentity['email']"
  [logoutText]="t('Log out')"
  [profileText]="t('Profile settings')"
  (logout)="onLogout()"
  (goToProfile)="onProfile()"
  data-cy="header-profile-cx-profile-dropdown"/>
